module.exports = __webpack_public_path__ + "img/taiping.475386d0.svg";